import axios from "axios";
import React, { useEffect, useState } from "react";
import Pagination from "../components/Pagination";
import Swal from "sweetalert2";
import Preloader1 from "../components/admin/Preloader1";

const AddCoachings = () => {
  const [coachings, setCoachings] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [ev, setEv] = useState("");
  const [checkboxValues, setCheckboxValues] = useState([]);
  const [error, setError] = useState("");

  const LIMIT = 12;

  useEffect(() => {
    serCoach();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    search(coachings);
    setCurrentPage(1);
  }, [ev]);

  const serCoach = async () => {
    setLoading(true);
    let { data } = await axios.get(`${process.env.REACT_APP_API_KEY}/sc`);
    setCoachings(data);
    setLoading(false);
  };

  const search = (data) => {
    return data.filter((item) =>
      item.name.toLowerCase().includes(ev.toLowerCase())
    );
  };

  const startIndex = (currentPage - 1) * LIMIT;
  const endIndex = startIndex + LIMIT;

  // .............................................................................

  // const handleCheckboxChange = (event, datas) => {
  //   const isChecked = event.target.checked;

  //   if (isChecked) {
  //     setCheckboxValues([...checkboxValues, datas]);
  //   } else {
  //     const updatedValues = checkboxValues.filter((item) => item !== datas);
  //     setCheckboxValues(updatedValues);
  //   }
  // };

  const handleCheckboxChange = (event, datas) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      const newValue = {
        ...datas,
        dName: datas.name,
      };
      setCheckboxValues([...checkboxValues, newValue]);
    } else {
      const updatedValues = checkboxValues.filter(
        (item) => item.name !== datas.name
      );
      setCheckboxValues(updatedValues);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/selCoach`,
        {
          batch: checkboxValues,
        }
      );

      if (!response.status === 200) {
        setError("Error");
      }

      if (response.status === 200) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Batches Added Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        serCoach();
      }
    } catch (error) {
      console.error("Error sending data:", error.response.data);
      setError("Error Occured");
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-xl-12 mb-4">
            <div className="card">
              <h5 className="card-header">Select Courses To Display</h5>
              <div className="mx-4">
                <button
                  className="btn btn-block btn-success w-100 px-5"
                  type="submit"
                >
                  Submit
                </button>
              </div>
              {loading ? (
                <Preloader1 />
              ) : (
                <>
                  <div className="card-body">
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4">
                      {coachings
                        .slice(startIndex, endIndex)
                        .map((datas, index) => {
                          let d = [];
                          d = datas.name.split("_");
                          return (
                            <div className="col-md mb-md-0 mb-2" key={index}>
                              <div className="form-check custom-option custom-option-icon">
                                <label
                                  className="form-check-label custom-option-content"
                                  htmlFor={`customCheckbox${index}`}
                                >
                                  <span className="custom-option-body">
                                    <svg
                                      width={59}
                                      height={58}
                                      viewBox="0 0 59 58"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M48.9019 33.6218L41.7878 25.0804C42.0597 30.314 40.7683 36.4086 36.7808 43.364L43.5777 48.8015C43.8194 48.9935 44.1061 49.1205 44.4106 49.1706C44.7151 49.2207 45.0274 49.1922 45.3178 49.0879C45.6083 48.9835 45.8673 48.8067 46.0702 48.5742C46.2732 48.3417 46.4134 48.0612 46.4777 47.7593L49.2644 35.1625C49.3316 34.8954 49.3337 34.6161 49.2706 34.348C49.2076 34.08 49.0811 33.8309 48.9019 33.6218ZM10.2956 33.7578L17.4097 25.239C17.1378 30.4726 18.4292 36.5672 22.4167 43.5L15.6198 48.9375C15.3797 49.1294 15.0947 49.257 14.7916 49.3084C14.4885 49.3598 14.1773 49.3333 13.8873 49.2314C13.5973 49.1294 13.338 48.9554 13.1338 48.7256C12.9295 48.4958 12.7871 48.2179 12.7198 47.9179L9.93313 35.2984C9.86594 35.0313 9.8638 34.7521 9.92688 34.484C9.98995 34.2159 10.1164 33.9669 10.2956 33.7578Z"
                                        fill="currentColor"
                                        opacity="0.2"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M27.9017 3.71102C28.3979 3.30011 29.0221 3.07513 29.6666 3.07513C30.3127 3.07513 30.9383 3.30117 31.435 3.71394C33.6315 5.50224 38.386 9.93871 41.0105 16.7606C41.9219 19.1296 42.5713 21.7739 42.7735 24.6785L49.8022 33.113C50.0828 33.4423 50.2809 33.8338 50.38 34.255C50.4785 34.6735 50.4764 35.1093 50.374 35.5267L47.5901 48.1336L47.5894 48.1367C47.485 48.6022 47.264 49.0335 46.9471 49.39C46.6302 49.7465 46.2278 50.0166 45.7778 50.1748C45.3278 50.333 44.8449 50.3742 44.3746 50.2944C43.9043 50.2146 43.4621 50.0165 43.0894 49.7188L43.0889 49.7184L36.566 44.5H22.7675L16.2445 49.7184L16.2441 49.7188C15.8714 50.0165 15.4291 50.2146 14.9588 50.2944C14.4885 50.3742 14.0057 50.333 13.5556 50.1748C13.1056 50.0166 12.7032 49.7465 12.3863 49.39C12.0694 49.0335 11.8484 48.6022 11.7441 48.1367L11.7434 48.1336L8.95943 35.5267C8.85707 35.1093 8.85499 34.6735 8.95346 34.255C9.05262 33.8335 9.25088 33.4419 9.53173 33.1125L16.4274 24.8553C16.6112 21.877 17.2734 19.1695 18.2135 16.7491C20.8639 9.92541 25.6801 5.4896 27.9017 3.71102ZM40.8041 25.2385C40.7893 25.1573 40.7846 25.0748 40.7899 24.993C40.6159 22.2127 40.0004 19.7051 39.1438 17.4787C36.6951 11.1136 32.2331 6.94203 30.1682 5.26158L30.1583 5.25355L30.1584 5.25349C30.0204 5.13826 29.8464 5.07513 29.6666 5.07513C29.4868 5.07513 29.3128 5.13826 29.1748 5.25349L29.1585 5.26684C27.0721 6.93594 22.5504 11.1072 20.0778 17.4732C19.1887 19.7623 18.5587 22.3492 18.4096 25.2244C18.4102 25.2674 18.4081 25.3106 18.4032 25.3535C18.1745 30.253 19.3435 35.9842 22.9982 42.5H36.3292C39.938 35.9325 41.0647 30.1631 40.8041 25.2385ZM48.2696 34.398L42.8122 27.8492C42.6094 32.4348 41.2748 37.5835 38.2005 43.2464L44.3378 48.1563C44.4455 48.2423 44.5733 48.2995 44.7091 48.3226C44.845 48.3456 44.9845 48.3337 45.1145 48.288C45.2445 48.2423 45.3607 48.1643 45.4523 48.0613C45.5436 47.9586 45.6073 47.8344 45.6376 47.7004L45.6378 47.6992L48.4239 35.0828L48.4272 35.0682L48.4305 35.0545C48.4587 34.9425 48.4596 34.8255 48.4332 34.7131C48.4067 34.6007 48.3537 34.4963 48.2786 34.4086L48.2695 34.3981L48.2696 34.398ZM16.4139 27.9916L11.0632 34.3988L11.0549 34.4087L11.0549 34.4086C10.9798 34.4963 10.9267 34.6007 10.9003 34.7131C10.8738 34.8254 10.8747 34.9425 10.9029 35.0545C10.9053 35.0639 10.9075 35.0734 10.9096 35.0828L13.6956 47.6992L13.6959 47.7005C13.7262 47.8345 13.7899 47.9586 13.8812 48.0613C13.9727 48.1643 14.089 48.2423 14.219 48.288C14.349 48.3337 14.4885 48.3456 14.6243 48.3226C14.7602 48.2995 14.888 48.2423 14.9956 48.1563L21.1271 43.2511C18.0233 37.6471 16.6517 32.5443 16.4139 27.9916ZM25.0417 50.75C25.0417 50.1977 25.4895 49.75 26.0417 49.75H33.2917C33.844 49.75 34.2917 50.1977 34.2917 50.75C34.2917 51.3023 33.844 51.75 33.2917 51.75H26.0417C25.4895 51.75 25.0417 51.3023 25.0417 50.75ZM32.3855 21.75C32.3855 23.2515 31.1683 24.4688 29.6667 24.4688C28.1652 24.4688 26.948 23.2515 26.948 21.75C26.948 20.2485 28.1652 19.0313 29.6667 19.0313C31.1683 19.0313 32.3855 20.2485 32.3855 21.75Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                    <span className="custom-option-title">
                                      {d}
                                    </span>
                                    <small>
                                      Check Or Uncheck This Course To Show Or
                                      Hide.
                                    </small>
                                  </span>
                                  {/* <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`customCheckbox${index}`}
                                    value={datas}
                                    checked={checkboxValues.includes(datas)}
                                    onChange={(event) =>
                                      handleCheckboxChange(event, datas)
                                    }
                                  /> */}
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`customCheckbox${index}`}
                                    value={datas.name}
                                    checked={checkboxValues.some(
                                      (item) => item.name === datas.name
                                    )}
                                    onChange={(event) =>
                                      handleCheckboxChange(event, datas)
                                    }
                                  />
                                </label>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <Pagination
          total={coachings?.length}
          limit={LIMIT}
          page={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </form>
    </>
  );
};

export default AddCoachings;
